import {Brick, registerBrick, ErrorFlow} from 'olympe';

export default class MDAPIReadResultFromResponsesBody extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {number} statusCode
     * @param {string} responsesBody
     * @param {function(string)} setResult
     * @param {function(*)} setErrorFlow
     */
    update($, [statusCode, responsesBody], [setResult, setErrorFlow]) {
        if (statusCode >= 300) {
            setResult(responsesBody);
            return;
        }

        try {
            setResult(JSON.stringify(JSON.parse(responsesBody).d.results));
        } catch (e) {
            setErrorFlow(ErrorFlow.create(`Error while reading the response body (0188758e110162941ff7). ${e}`, 1));
        }
    }
}

registerBrick('0188758e110162941ff7', MDAPIReadResultFromResponsesBody);
